var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeguroAgricola(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73 83.7",
    style: {
      enableBackground: "new 0 0 73 83.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#95D4E9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#95D4E9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Seguro_Agr\\xEDcola",
    transform: "translate(-912.5 -191.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18999",
    className: "st0",
    d: "M956.1,199.6c0,3.9-7.1,14.2-7.1,14.2s-7.1-10.3-7.1-14.2c0-3.9,3.2-7.1,7.1-7.1 C952.9,192.5,956.1,195.7,956.1,199.6L956.1,199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19000",
    className: "st0",
    d: "M931.3,210.3c3.9,0,14.2,7.1,14.2,7.1s-10.3,7.1-14.2,7.1c-3.9,0-7.1-3.2-7.1-7.1 C924.2,213.4,927.3,210.3,931.3,210.3L931.3,210.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19001",
    className: "st0",
    d: "M941.9,235.1c0-3.9,7.1-14.2,7.1-14.2s7.1,10.3,7.1,14.2c0,3.9-3.2,7.1-7.1,7.1 C945.1,242.2,941.9,239,941.9,235.1L941.9,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19002",
    className: "st0",
    d: "M966.8,224.5c-3.9,0-14.2-7.1-14.2-7.1s10.3-7.1,14.2-7.1c3.9,0,7.1,3.2,7.1,7.1 C973.9,221.3,970.7,224.5,966.8,224.5C966.8,224.5,966.8,224.5,966.8,224.5L966.8,224.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19003",
    className: "st1",
    d: "M949,274.2c7.1-24.9,14.2-35.5,35.5-35.5C970.3,260,970.3,274.2,949,274.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19004",
    className: "st1",
    d: "M949,274.2c-7.1-24.9-14.2-35.5-35.5-35.5C927.7,260,927.7,274.2,949,274.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguroAgricola);
export default __webpack_public_path__ + "static/media/Seguro-Agricola.1e0ed751e89d476cda7f7461909aa1eb.svg";
export { ForwardRef as ReactComponent };